const ActivityFeedGroupFilterOption = {
  ADDED_TO_PLAYLIST: "ADDED_TO_PLAYLIST",
  ALL: "ALL",
  COLLECTED: "COLLECTED",
  LIKES: "LIKES",
  RELEASE_DROPPED: "RELEASE_DROPPED"
};
const ActivityFeedType = {
  GLOBAL: "GLOBAL",
  NOTABLE_COLLECTORS: "NOTABLE_COLLECTORS",
  USER: "USER"
};
const ArtistActivityFeedActivityTypeFilterOption = {
  ALL: "ALL",
  COLLECTIONS: "COLLECTIONS",
  LIKES: "LIKES",
  PLAYLISTS: "PLAYLISTS",
  RELEASES: "RELEASES"
};
const ArtistActivityFeedTypeFilterOption = {
  ALL: "ALL",
  ARTIST: "ARTIST",
  COLLECTOR: "COLLECTOR",
  RELEASE: "RELEASE"
};
const ArtistApplicationStatus = {
  ACCEPTED: "ACCEPTED",
  PENDING: "PENDING",
  REJECTED: "REJECTED"
};
const ArtistReleasesAuthorFilterOption = {
  ALL: "ALL",
  ONLY_APPEARS_ON: "ONLY_APPEARS_ON",
  ONLY_AUTHORED_RELEASES: "ONLY_AUTHORED_RELEASES"
};
const ArtistReleasesCreditSplitFilterOption = {
  ALL: "ALL",
  ONLY_CREDIT_SPLITS: "ONLY_CREDIT_SPLITS",
  ONLY_NO_CREDIT_SPLITS: "ONLY_NO_CREDIT_SPLITS"
};
const ArtistSeason = {
  GENESIS: "GENESIS",
  SEASON_FOUR: "SEASON_FOUR",
  SEASON_ONE: "SEASON_ONE",
  SEASON_THREE: "SEASON_THREE",
  SEASON_TWO: "SEASON_TWO"
};
const AuctionType = {
  FIXED_QUANTITY: "FIXED_QUANTITY",
  OPEN_EDITION: "OPEN_EDITION",
  OPEN_EDITION_WITH_SAM: "OPEN_EDITION_WITH_SAM",
  RANGE_BOUND: "RANGE_BOUND"
};
const CollectionMarketType = {
  AIRDROP: "AIRDROP",
  BONDING_CURVE_SALE: "BONDING_CURVE_SALE",
  PRIMARY_SALE: "PRIMARY_SALE",
  SECONDARY_SALE: "SECONDARY_SALE"
};
const CollectorActivityFeedTypeFilterOption = {
  ALL: "ALL",
  COLLECTIONS: "COLLECTIONS",
  LIKES: "LIKES",
  PLAYLISTS: "PLAYLISTS"
};
const ContractType = {
  ARTIST: "ARTIST",
  EDITION: "EDITION"
};
const CreditRoleType = {
  ARTIST: "ARTIST",
  CURATOR: "CURATOR",
  OTHER: "OTHER",
  PRODUCER: "PRODUCER",
  REMIXER: "REMIXER",
  SONGWRITER: "SONGWRITER",
  VISUAL_ARTIST: "VISUAL_ARTIST"
};
const DraftAllowlistType = {
  ARTIST_COLLECTORS: "ARTIST_COLLECTORS",
  MANUALLY_ADDED_COLLECTORS: "MANUALLY_ADDED_COLLECTORS",
  RELEASE_COLLECTORS: "RELEASE_COLLECTORS"
};
const EventType = {
  AIRDROP: "AIRDROP",
  EDITION_PURCHASED: "EDITION_PURCHASED",
  ORDERS_MATCHED: "ORDERS_MATCHED",
  OTHER_MINTED: "OTHER_MINTED",
  TRANSFER: "TRANSFER",
  UNKNOWN: "UNKNOWN"
};
const KeyClientStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE"
};
const LicenseType = {
  ALL_RIGHTS_RESERVED: "ALL_RIGHTS_RESERVED",
  CREATIVE_COMMONS: "CREATIVE_COMMONS"
};
const MediaType = {
  ARTIST_BANNER_IMAGE: "ARTIST_BANNER_IMAGE",
  ARTIST_COLLECTORS_CSV: "ARTIST_COLLECTORS_CSV",
  ARTIST_FREE_SALE_ALLOWLIST: "ARTIST_FREE_SALE_ALLOWLIST",
  ARTIST_PRESALE_ALLOWLIST: "ARTIST_PRESALE_ALLOWLIST",
  AUDIO: "AUDIO",
  AUDIO_128K: "AUDIO_128K",
  AUDIO_192K: "AUDIO_192K",
  AUDIO_256K: "AUDIO_256K",
  AVATAR_IMAGE: "AVATAR_IMAGE",
  DRAFT_ALLOWLISTED_ADDRESSES_CSV: "DRAFT_ALLOWLISTED_ADDRESSES_CSV",
  RELEASE_BANNER_IMAGE: "RELEASE_BANNER_IMAGE",
  RELEASE_COVER_IMAGE: "RELEASE_COVER_IMAGE",
  RELEASE_GOLDEN_EGG_IMAGE: "RELEASE_GOLDEN_EGG_IMAGE",
  RELEASE_HOLDERS_CSV: "RELEASE_HOLDERS_CSV",
  RELEASE_WEB_ANIMATED_GOLDEN_EGG_IMAGE: "RELEASE_WEB_ANIMATED_GOLDEN_EGG_IMAGE",
  RELEASE_WEB_ANIMATED_IMAGE: "RELEASE_WEB_ANIMATED_IMAGE",
  RELEASE_WEB_STATIC_AUTOGEN_IMAGE: "RELEASE_WEB_STATIC_AUTOGEN_IMAGE",
  RELEASE_WEB_STATIC_IMAGE: "RELEASE_WEB_STATIC_IMAGE",
  TMP_ARTIST_BANNER_AUTOGEN_IMAGE: "TMP_ARTIST_BANNER_AUTOGEN_IMAGE",
  TMP_AVATAR_AUTOGEN_IMAGE: "TMP_AVATAR_AUTOGEN_IMAGE",
  TMP_USER_BANNER_AUTOGEN_IMAGE: "TMP_USER_BANNER_AUTOGEN_IMAGE",
  USER_BANNER_IMAGE: "USER_BANNER_IMAGE"
};
const MintTimeStatus = {
  PAST: "PAST",
  UPCOMING: "UPCOMING"
};
const PlatformType = {
  ANDROID: "ANDROID",
  IOS: "IOS",
  WEB: "WEB"
};
const PlaylistType = {
  ARTIST: "ARTIST",
  HOLDER: "HOLDER",
  HOME: "HOME"
};
const ReleaseActivityFeedTypeFilterOption = {
  ALL: "ALL",
  COLLECTIONS: "COLLECTIONS",
  LIKES: "LIKES",
  PLAYLISTS: "PLAYLISTS",
  RELEASES: "RELEASES"
};
const ReleaseAlbumRevealFilterOption = {
  ALL: "ALL",
  ONLY_NOT_REVEALED_ALBUMS: "ONLY_NOT_REVEALED_ALBUMS",
  ONLY_REVEALED_ALBUMS: "ONLY_REVEALED_ALBUMS"
};
const ReleaseFeaturedStatus = {
  ALL: "ALL",
  HOT: "HOT"
};
const ReleaseStatus = {
  AVAILABLE_TO_MINT: "AVAILABLE_TO_MINT",
  SOLD_OUT: "SOLD_OUT"
};
const ReleaseType = {
  ALBUM: "ALBUM",
  ALBUM_TRACK: "ALBUM_TRACK",
  SINGLE: "SINGLE"
};
const ShelfType = {
  DEFAULT: "DEFAULT",
  USER_LIKED_SOUNDS: "USER_LIKED_SOUNDS"
};
const ShelfTypeFilter = {
  ALL: "ALL",
  LIKED: "LIKED",
  USER_CREATED: "USER_CREATED"
};
const SongKeyType = {
  A_FLAT_MAJOR: "A_FLAT_MAJOR",
  A_MAJOR: "A_MAJOR",
  A_MINOR: "A_MINOR",
  B_FLAT_MAJOR: "B_FLAT_MAJOR",
  B_FLAT_MINOR: "B_FLAT_MINOR",
  B_MAJOR: "B_MAJOR",
  B_MINOR: "B_MINOR",
  C_MAJOR: "C_MAJOR",
  C_MINOR: "C_MINOR",
  C_SHARP_MINOR: "C_SHARP_MINOR",
  D_FLAT_MAJOR: "D_FLAT_MAJOR",
  D_MAJOR: "D_MAJOR",
  D_MINOR: "D_MINOR",
  E_FLAT_MAJOR: "E_FLAT_MAJOR",
  E_FLAT_MINOR: "E_FLAT_MINOR",
  E_MAJOR: "E_MAJOR",
  E_MINOR: "E_MINOR",
  F_MAJOR: "F_MAJOR",
  F_MINOR: "F_MINOR",
  F_SHARP_MAJOR: "F_SHARP_MAJOR",
  F_SHARP_MINOR: "F_SHARP_MINOR",
  G_MAJOR: "G_MAJOR",
  G_MINOR: "G_MINOR",
  G_SHARP_MINOR: "G_SHARP_MINOR"
};
const SortOrder = {
  ASC: "ASC",
  DESC: "DESC"
};
const TimePeriodAggEnum = {
  ALL_TIME: "ALL_TIME",
  ONE_DAY: "ONE_DAY",
  ONE_MONTH: "ONE_MONTH",
  SEVEN_DAY: "SEVEN_DAY"
};
const TopChartTimePeriodEnum = {
  ALL_TIME: "ALL_TIME",
  SEVEN_DAY: "SEVEN_DAY",
  THIRTY_DAY: "THIRTY_DAY"
};
const TopCuratorsSortEnum = {
  MINTS: "MINTS",
  SOUNDS_REFERRED: "SOUNDS_REFERRED",
  TOTAL_AFFILIATE_EARNED: "TOTAL_AFFILIATE_EARNED",
  TOTAL_VOLUME: "TOTAL_VOLUME"
};
const TrendingArtistsSortEnum = {
  NFTS_SOLD: "NFTS_SOLD",
  PRIMARY_SALES: "PRIMARY_SALES",
  SECONDARY_SALES: "SECONDARY_SALES",
  TOTAL_SALES: "TOTAL_SALES",
  UNIQUE_COLLECTORS: "UNIQUE_COLLECTORS"
};
const TrendingCollectorsSortEnum = {
  CREATORS_SUPPORTED: "CREATORS_SUPPORTED",
  NFTS_BOUGHT: "NFTS_BOUGHT",
  TOTAL_SPENT: "TOTAL_SPENT"
};
const TrendingIndicator = {
  DOWN: "DOWN",
  NEW: "NEW",
  SAME: "SAME",
  UP: "UP"
};
const TrendingPlaylistsSortEnum = {
  LIKES: "LIKES"
};
const TrendingReleasesSortEnum = {
  NFTS_SOLD: "NFTS_SOLD",
  PRIMARY_SALES: "PRIMARY_SALES",
  SECONDARY_SALES: "SECONDARY_SALES",
  TOTAL_SALES: "TOTAL_SALES",
  UNIQUE_COLLECTORS: "UNIQUE_COLLECTORS"
};
const TypeOfRelation = {
  FOLLOWING: "FOLLOWING"
};
const MerkleProof = `query MerkleProof($root:String!$unhashedLeaf:String!){merkleTreeProof(root:$root unhashedLeaf:$unhashedLeaf){proof}}`;
const ReleaseInfo = `query ReleaseInfo($contractAddress:Address!$editionId:String){release:releaseFromContract(contractAddress:$contractAddress editionId:$editionId){id contractAddress editionId type mintStartTime mintStartTimestamp webappUri externalUrl marketPlaceUrl title behindTheMusic season scheduleIds{mintIds minterAddress}genre{id name}track{id duration audio{audio128k{id url}audio192k{id url}audio256k{id url}audioOriginal{id url}}}artist{id webappUri season soundHandle bannerImage{id url}user{id publicAddress description displayName twitterHandle avatar{id url}}}rewards{id description title}coverImage{id url}goldenEggImage{id url}eggGame{id winningSerialNum}}}`;
const ReleaseShareInfo = `query ReleaseShareInfo($contractAddress:Address!$editionId:String$releaseWebappUriInput:ReleaseWebappUriInput$releaseEmbedUriInput:ReleaseWebEmbedInput){release:releaseFromContract(contractAddress:$contractAddress editionId:$editionId){id contractAddress editionId type mintStartTime mintStartTimestamp webappUri(input:$releaseWebappUriInput)webEmbed(input:$releaseEmbedUriInput)coverImage{id url}track{id duration audio{audio128k{id url}audio192k{id url}audio256k{id url}audioOriginal{id url}}}}}`;
const Test = `query Test{__typename}`;
const EditionOwnedTokenIds = `query EditionOwnedTokenIds($input:EditionOwnedTokenIdsInput!){editionOwnedTokenIds(input:$input)}`;

export { ActivityFeedGroupFilterOption, ActivityFeedType, ArtistActivityFeedActivityTypeFilterOption, ArtistActivityFeedTypeFilterOption, ArtistApplicationStatus, ArtistReleasesAuthorFilterOption, ArtistReleasesCreditSplitFilterOption, ArtistSeason, AuctionType, CollectionMarketType, CollectorActivityFeedTypeFilterOption, ContractType, CreditRoleType, DraftAllowlistType, EditionOwnedTokenIds, EventType, KeyClientStatus, LicenseType, MediaType, MerkleProof, MintTimeStatus, PlatformType, PlaylistType, ReleaseActivityFeedTypeFilterOption, ReleaseAlbumRevealFilterOption, ReleaseFeaturedStatus, ReleaseInfo, ReleaseShareInfo, ReleaseStatus, ReleaseType, ShelfType, ShelfTypeFilter, SongKeyType, SortOrder, Test, TimePeriodAggEnum, TopChartTimePeriodEnum, TopCuratorsSortEnum, TrendingArtistsSortEnum, TrendingCollectorsSortEnum, TrendingIndicator, TrendingPlaylistsSortEnum, TrendingReleasesSortEnum, TypeOfRelation };
